"use strict";
import Vector from "immutable-vector2d";
import { MOVING_START, MOVING_FINISH } from "../actions";
export default function moveComponentReducer(movingComponent = {}, action) {
  switch (action.type) {
    case MOVING_START: {
      const { component, dragPointIndex, mouseVector } = action;
      return {
        guid: component.guid,
        from: mouseVector,
        origDragPoints: component.dragPoints,
        origPosition: new Vector(component.x, component.y),
        origSize: { width: component.width, height: component.height },
        dragPointIndex
      };
    }
    case MOVING_FINISH: {
      return {};
    }
    default:
      return movingComponent;
  }
}
